export const getTableSize = (state) => state.postflop.tableSize;
export const getStackSize = (state) => state.postflop.stackSize;
export const getPositionType = (state) => state.postflop.positionType;
export const getPosition = (state) => state.postflop.position;
export const getResultsPositionType = (state) => state.postflop.resultsPositionType;
export const getResultsPfrType = (state) => state.postflop.resultsPfrType;
export const getResultsPlayerPosition = (state) => state.postflop.resultsPlayerPosition;
export const getResultsPosition = (state) => state.postflop.resultsPosition;
export const getResultsPreviousAction = (state) => state.postflop.resultsPreviousAction;
export const getBoardType = (state) => state.postflop.boardType;
export const getSelectedBoard = (state) => state.postflop.selectedBoard;
export const getSelectedCards = (state) => state.postflop.selectedCards;
export const getPageMode = (state) => state.postflop.pageMode;
export const getSelectedHandType = (state) => state.postflop.selectedHandType;
